import { Link } from "react-router-dom";
import FormBuilder from "../../common/components/formInputs/FormBuilder";

function getFormInputs() {
  return [
    {
      type: "text",
      name: "email",
      label: "Email",
      placeholder: "name@example.com",
      validation: {
        required: "Email is required",
        pattern: {
          value: /^\S+@\S+$/,
          message: "Invalid email address",
        },
      },
    },
  ];
}

function ForgotPassword({ onSubmit, isSubmitting }) {
  return (
    <div className="text-gray-700 md:10/12 lg:w-6/12">
      <div className="font-bold text-center my-2 mb-4 text-2xl font-bold">
        Forgot Password
      </div>

      <FormBuilder
        formInputs={getFormInputs()}
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
      />

      <div className="flex justify-center items-center space-x-2 text-gray-500 pb-2">
        <div>Go to</div>

        <div>
          <Link to="/login" className="back_link underline">
            Login
          </Link>
        </div>
        <div>or</div>
        <div>
          <Link to="/signup" className="back_link underline">
            Sign Up
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
